import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

export function DashboardPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="text-3xl">🐱</span>
          <h1 className="text-xl font-bold text-purple-600">MIMI v2</h1>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm text-gray-600">{user?.name}</span>
          <button onClick={logout} className="text-sm text-red-500 hover:underline">ออกจากระบบ</button>
        </div>
      </header>
      <div className="p-6 max-w-4xl mx-auto">
        <h2 className="text-2xl font-bold mb-6">Dashboard</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          {[{ label: 'ข้อความวันนี้', value: '0', icon: '💬', color: 'bg-blue-50 border-blue-200' },
            { label: 'AI Reply', value: '0', icon: '🤖', color: 'bg-purple-50 border-purple-200' },
            { label: 'ผู้ใช้งาน', value: '1', icon: '👥', color: 'bg-green-50 border-green-200' }
          ].map(s => (
            <div key={s.label} className={`p-6 rounded-xl border ${s.color}`}>
              <div className="text-3xl mb-2">{s.icon}</div>
              <p className="text-2xl font-bold">{s.value}</p>
              <p className="text-sm text-gray-500">{s.label}</p>
            </div>
          ))}
        </div>
        <div className="bg-white rounded-xl shadow p-6 mb-6">
          <h3 className="font-semibold mb-4">📋 Conversations</h3>
          <div className="text-gray-400 text-center py-8">
            <p className="text-4xl mb-2">🐱</p>
            <p>ยังไม่มีการสนทนา</p>
            <button onClick={() => navigate('/app/chat/new')} className="mt-4 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700">
              เริ่มสนทนาใหม่
            </button>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow p-6">
          <h3 className="font-semibold mb-4">🧠 Knowledge Base</h3>
          <p className="text-gray-400 text-center py-4">ยังไม่มีข้อมูล</p>
        </div>
      </div>
    </div>
  );
}
